import React, { useContext, useEffect, useMemo, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import Header from "../../components/Header/Header"
import logo from "../../assets/tap2tech/planet.png"
import HeaderLogin from "../../components/HeaderLogin/HeaderLogin"
import { FirebaseFuntions } from "../../context/FirebaseContext"
import MainCointainer from "../../components/MainCointainer/MainCointainer"
import { motion, AnimatePresence } from "framer-motion"
import { Link } from "react-router-dom"

const applinks = {
    android : "https://play.google.com/store/apps/details?id=com.gnp&hl=es_MX&gl=US",    
    web : "https://www.gnp.com.mx/soy-cliente",
    ios : "https://apps.apple.com/mx/app/soy-cliente-gnp/id540222216"
}

const Dashboard = () => {
    const { loginFlag, searchUser, authStatus, authID, projectPhoto} = useContext(FirebaseFuntions);   
    const { userId } = useParams()
    const { projectId } = useParams()
    const [user, setUser] = useState("")
    const createAccount = useNavigate()
    const [device, setDevice] = useState("")
    const [typeOfDevice, setTypeOfDevice] = useState("")
    const [loader, setLoader] = useState(false)
    const [projectLogo, setProjectLogo] = useState({})

    useMemo(() => {
        if (userId || projectId) {
            const data = searchUser(userId, projectId);
            data.then((res) => {
                setUser(res);                
            });
        }                
    }, [userId, projectId, searchUser]);

    

    useEffect(() => {
        if (user === null ) {
            createAccount(`/${projectId}/create/${userId}`);            
            console.log("no existe");        
        }  
        const respuesta = projectPhoto(projectId)
        respuesta.then((res) => {            
            setProjectLogo(res)
        })
        authStatus();
        //console.log(user?.role)     
        if (/android/i.test(navigator.userAgent)) {            
            setDevice(applinks.android);
            setTypeOfDevice("Android");
        } else if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {            
            setDevice(applinks.ios);
            setTypeOfDevice("iOS");
        } else {            
            setDevice(applinks.web);
            setTypeOfDevice("Web");
        } 
        handleLoader();      
    }, [user, createAccount, userId, projectId, authStatus, device, authID, projectPhoto]);

    const handleLoader = () => {
        setTimeout(() => {
            setLoader(true)
        }, 3500)
    }

    if (user?.role === "subadmin" || loginFlag === false) {
        return (
            <>
                {loginFlag ? (    
                    loader && user ? (                
                        authID === user.authID ? (
                            <>                    
                                <Header
                                    props = {{
                                        userId,
                                        projectId                            
                                    }}
                                />
                                <MainCointainer
                                    user={user}    
                                    device={device}     
                                    typeOfDevice={typeOfDevice}               
                                    projectLogo={projectLogo}
                                />
                            </>
                        ) :(
                            <div className="md:w-4/12 sm:w-auto top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 text-center absolute">
                                <div>
                                    <h1 className="uppercase font-bold font-heading">No tienes permiso para ver otro perfil hasta cerrar sesión</h1>
                                </div>                        
                            </div>
                        )
                    ) : (
                        <AnimatePresence>
                            <div className="md:w-4/12 sm:w-auto top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 text-center absolute">
                                <motion.img 
                                    initial={{ rotateY: 0 }}
                                    animate={{ rotateY: 360 }}
                                    transition={{ duration: 2, repeat: Infinity, type: "tween", repeatDelay: 0 }}
                                    exit={{ opacity: 0 }}
                                    src={logo}
                                    alt="logo tap2tech" 
                                    className="mx-auto mb-5" 
                                    width={150} height={150} 
                                />
                                <p className="uppercase text-lg">Cargando</p>                      
                            </div>
                        </AnimatePresence>
                    )     
                ) : ( 

                    loader && user ? (
                        <div className="md:w-4/12 sm:w-auto top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 text-center absolute">
                            <div>
                                <h1 className="uppercase font-bold font-heading mb-4">Inicia sesión como administrador</h1>
                                <Link to="/" className="bg-tap2tech_sec text-black font-bold my-3 py-2 px-4 rounded-lg uppercase focus:outline-none font-body">Regresar a la página principal</Link>                                
                            </div>                        
                        </div>
                     ) : (
                        <AnimatePresence>
                            <div className="md:w-4/12 sm:w-auto top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 text-center absolute">
                                <motion.img 
                                    initial={{ rotateY: 0 }}
                                    animate={{ rotateY: 360 }}
                                    transition={{ duration: 2, repeat: Infinity, type: "tween", repeatDelay: 0 }}
                                    exit={{ opacity: 0 }}
                                    src={logo}
                                    alt="logo tap2tech" 
                                    className="mx-auto mb-5" 
                                    width={150} height={150} 
                                />
                                <p className="uppercase text-lg">Cargando</p>                      
                            </div>
                        </AnimatePresence>
                     )
                    )
                }
            </>
        )
    } else {
        return (
            <>  
                {loginFlag ? (    
                    loader && user ? (                
                        authID === user.authID ? (
                            <div className="md:w-4/12 sm:w-auto top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 text-center absolute">
                                <div>
                                    <h1 className="uppercase font-bold font-heading mb-4">No tienes permiso de administrador</h1>
                                    <Link to="/" className="bg-tap2tech_sec text-black font-bold my-3 py-2 px-4 rounded-lg uppercase focus:outline-none font-body">Regresar a la página principal</Link>                                
                                </div>                        
                            </div>
                        ) :(
                            <div className="md:w-4/12 sm:w-auto top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 text-center absolute">
                                <div>
                                    <h1 className="uppercase font-bold font-heading">No tienes permiso para ver otro perfil hasta cerrar sesión</h1>
                                </div>                        
                            </div>
                        )
                    ) : (
                        <AnimatePresence>
                            <div className="md:w-4/12 sm:w-auto top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 text-center absolute">
                                <motion.img 
                                    initial={{ rotateY: 0 }}
                                    animate={{ rotateY: 360 }}
                                    transition={{ duration: 2, repeat: Infinity, type: "tween", repeatDelay: 0 }}
                                    exit={{ opacity: 0 }}
                                    src={logo}
                                    alt="logo tap2tech" 
                                    className="mx-auto mb-5" 
                                    width={150} height={150} 
                                />
                                <p className="uppercase text-lg">Cargando</p>                      
                            </div>
                        </AnimatePresence>
                    )     
                ) : ( 

                    loader && user ? (
                    <>
                        <HeaderLogin />
                        <MainCointainer
                            user={user}
                            device={device}
                            typeOfDevice={typeOfDevice}       
                            projectLogo={projectLogo}      
                        />
                    </>
                     ) : (
                        <AnimatePresence>
                            <div className="md:w-4/12 sm:w-auto top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 text-center absolute">
                                <motion.img 
                                    initial={{ rotateY: 0 }}
                                    animate={{ rotateY: 360 }}
                                    transition={{ duration: 2, repeat: Infinity, type: "tween", repeatDelay: 0 }}
                                    exit={{ opacity: 0 }}
                                    src={logo}
                                    alt="logo tap2tech" 
                                    className="mx-auto mb-5" 
                                    width={150} height={150} 
                                />
                                <p className="uppercase text-lg">Cargando</p>                      
                            </div>
                        </AnimatePresence>
                     )
                    )
                }
                
            </>
        )                        
    }
    
}
export default Dashboard;